import React from 'react';
import { logError } from '../lib/logger';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    logError('ErrorBoundary', error);
    if (info?.componentStack && process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.error(info.componentStack);
    }
  }

  handleRetry = () => {
    this.setState({ hasError: false });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-white flex flex-col items-center justify-center px-6 text-center">
          <h1 className="text-xl font-medium text-zinc-900 mb-2" style={{ fontFamily: 'Outfit, sans-serif' }}>
            Qualcosa è andato storto
          </h1>
          <p className="text-zinc-600 text-sm mb-6 max-w-sm">
            Si è verificato un errore imprevisto. Ricarica l&apos;app per riprovare.
          </p>
          <button
            type="button"
            onClick={this.handleRetry}
            className="px-6 py-2.5 rounded-full bg-[#D4AF37] hover:bg-[#B8941F] text-white text-sm font-medium"
          >
            Ricarica
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
